import { NavigationGuardNext, Route } from 'vue-router';
import { LIST_PERMISSION } from '@/constant/ListPermission';
import { LIST_PLAN_ID } from '@/constant/PlansIDs';
import store from '@/store';
import Permission from './index';

export async function permissionDoubtsCredits(
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
) {
  const PermissionClass = new Permission();

  const hasCredits = await PermissionClass.can_credits(LIST_PERMISSION.DOUBTS_CREDITS);

  if (!hasCredits) {
    next({
      name: 'Doubts'
    });
  }

  next();
}

export function permissionDoubts(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();

  const hasPermission = PermissionClass.can(LIST_PERMISSION.DOUBTS);

  if (!hasPermission) {
    next({
      name: 'Doubts'
    });
  }
  next();
}

export function permissionDoubtsFeature(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();

  const hasPermission = PermissionClass.can(LIST_PERMISSION.DOUBTS_FEATURE);

  if (!hasPermission) {
    next({
      name: 'Dashboard'
    });
  }

  next();
}

export function permissionDoubtsWithFree(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();

  const isHighSchool = PermissionClass.can(LIST_PERMISSION.BOOKS_DEGREE_HIGH_SCHOOL);
  const isPlanner = PermissionClass.can(LIST_PERMISSION.DOUBTS_FEATURE);
  const isPlanFree = store.getters.profile?.plan?.planID === LIST_PLAN_ID.FREE;

  const hasAccess = (isHighSchool && isPlanner) || isPlanFree;

  if (hasAccess) {
    next(); 
    return;
  }

  next({ name: 'Dashboard' });
}
